import React from "react";
import styles from "./ssoFailure.module.scss";
import { useNavigate } from "react-router-dom";
import Button from "src/components/button";

function SSOFailure() {
  const navigate = useNavigate();

  return (
    <div className={styles.ssoFailureContainer}>
      <img
        src="/images/Paperflite.png"
        alt="Paperflite Logo"
        className={styles.logo}
      />
      <h1 className={styles.title}>
        We are unable to grant you access to this service because one or more of
        your Single Sign-On login credentials is invalid. Please try again!
      </h1>
      <Button
        variant="primary"
        icon="paperflite-right-arrow"
        text="Back to Login"
        onClick={() => navigate("/public/login")}
      />
    </div>
  );
}

export default SSOFailure;
